// Intersection observer, but it removes intersected element from the observer
export default class {
  constructor(callback, options) {
    this.observer = new IntersectionObserver((...args) => this.callbackWrapper(...args), options);

    this.callback = callback;
    this.initialCall = true;
  }

  callbackWrapper(entries) {
    const isFirstCall = this.initialCall;
    const intersectingEntries = entries.filter((entry) => {
      if (entry.isIntersecting) {
        this.observer.unobserve(entry.target);
        return true;
      }
      return false;
    });

    if (intersectingEntries.length === 0) {
      this.initialCall = false;
      return;
    }

    if (isFirstCall) this.initialCall = false;

    this.callback(intersectingEntries, isFirstCall);
  }

  observe(element) {
    this.observer.observe(element);
  }

  unobserve(element) {
    this.observer.unobserve(element);
  }
}
